import { graphql } from "@opensea/graphql"
import type { Client } from "urql"

const topupQuery = graphql(`
  query fetchMoonPayTopupWidgetUrlSignatureQuery($url: String!) {
    topupWidget(url: $url) {
      signature
    }
  }
`)

export const fetchMoonPayUrlSignature = async (url: string, client: Client) => {
  const { data } = await client.query(topupQuery, {
    url,
  })

  return data?.topupWidget.signature ?? ""
}

const nftCheckoutQuery = graphql(`
  query fetchMoonPayNftCheckoutWidgetUrlSignatureQuery($url: String!) {
    nftCheckoutWidget(url: $url) {
      signature
    }
  }
`)

export const fetchMoonPayCheckoutUrlSignature = async (
  url: string,
  client: Client,
) => {
  const { data } = await client.query(nftCheckoutQuery, {
    url,
  })

  return data?.nftCheckoutWidget.signature ?? ""
}
